<template>
  <div class="item-modal">
    <form action="" @submit.prevent="submitItemData">
      <div class="card-body">
        <h3 class="text-right">APPENDIX - B</h3>
        <h3 class="text-center"><u>WRITTEN OFFER</u></h3>
        <p class="text-center">(To be obtained on Customer’s company letter head)</p>
        <div>
          <span>September 21, 2022</span><br><br>
          <span>To,</span><br>
          <span>HabibMetro Islamic Banking</span><br>
          <span>Main Branch</span><br>
          <span>II Chundrigar Road</span><br><br>
          <span>Dear Sirs,</span>
        </div>
        <div style="width: 80%;margin: auto;">
          <h4 class="text-center"><u>Written offer for the sale of Goods</u></h4>
          <p class="text-center">We (the “Customer”) are pleased to confirm our willingness to sell the following Goods subject to the following terms and conditions:</p>

          <ol type="a" class="bracketed-list">
            <li>Description of the Goods:
              <input type="text" id="content1" class="form-control"></li>
            <li>Quantity of Goods:
              <input type="text" id="content2" class="form-control"></li>
            <li>Specification of Goods:
              <input type="text" id="content3" class="form-control"></li>
            <li>Delivery Date:
              <input type="text" id="content4" class="form-control"></li>
            <li>Goods Price:
              <input type="text" id="content5" class="form-control"></li>
            <li>Point of Delivery:
              <input type="text" id="content6" class="form-control"></li>
          </ol>
          <p>All terms and conditions (including the definitions) of the Master Agreement shall apply to this Written Offer.</p>
        </div>
        <p>IN WITNESS WHEREOF, the Customer has executed and delivered this Written Offer as of the date mentioned here in above.</p>
        <div>
          <span>Yours faithfully,</span><br><br><br>
          <span>__________Customer Signature_____________________</span><br>
          <span>For and on Behalf of the Customer</span>
        </div>
      </div>

      <div class="card-footer justify-content-between align-items-center">
        <div>
          <div class="custom-control custom-checkbox">
            <input
              id="confirm"
              v-model="confirmContract"
              type="checkbox"
              class="custom-control-input"
            >
            <label for="confirm" class="custom-control-label">Confirm Contract</label>
          </div>
          <div v-if="$v.confirmContract.$error">
            <span v-if="!$v.confirmContract.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
          </div>
        </div>
        <div class="d-flex">
          <base-button
            :outline="true"
            class="mr-3"
            color="theme"
            type="button"
            @click="closeItemModal"
          >
            {{ $t('general.cancel') }}
          </base-button>
          <base-button
            v-if="isEdit"
            :loading="isLoading"
            color="theme"
            @click="submitItemData"
          >
            {{ name }}
          </base-button>
          <base-button
            v-else
            :loading="isLoading"
            icon="save"
            color="theme"
            type="submit"
          >
            {{ $t('general.save') }}
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      isEdit: false,
      isLoading: false,
      name: null,
      confirmContract: null,
      formData:{
        content: []
      }
    }
  },
  validations: {
    confirmContract: {
      required
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData'
    ])
  },
  watch: {
    modalDataID () {
      this.isEdit = true
      this.setData()
    }
  },
  created () {
    if (this.modalDataID) {
      this.isEdit = true
    }
  },
  mounted () {
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'openModal',
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('OfferToSell', [
      'markAsOffer'
    ]),
    resetFormData () {
      this.name = null
      this.confirmContract = null
      this.formData.content = []
    },
    async setData () {
      if (this.modalData['name'] === 'Offer Accepted') {
        this.name = 'Accept Offer'
      } else {
        this.name = this.modalData['name']
      }
    },
    async submitItemData () {
      this.$v.confirmContract.$touch()
      if (this.$v.$invalid) {
        return true
      }

      const inputs = document.querySelectorAll('.bracketed-list input.form-control');

      const formDataArray = [];
      inputs.forEach((input) => {
        formDataArray.push(input.value);
      });

      const data = {
        islamic_finance_id: this.modalDataID,
        content_data: formDataArray
      }

      let response = await this.markAsOffer(data)
      if (response.data.success) {
        window.toastr['success'](this.$tc('islamic_finance.mark_as_offer_message'))
      }

      this.closeItemModal()
      this.isLoading = false
      return true
    },
    closeItemModal () {
      this.resetFormData()
      this.closeModal()
      this.resetModalData()
    }
  }
}
</script>
<style scoped>
.card-body{
  max-height: 500px !important;
  overflow: auto !important;;
}

/* Style for bracketed alphabetic list items */
ol.bracketed-list {
  counter-reset: item;
  padding-left: 30px;
}

ol.bracketed-list li {
  list-style: none;
  margin-bottom: 40px;
}

ol.bracketed-list li:before {
  content: "(" counter(item, lower-alpha) ")";
  counter-increment: item;
  display: inline-block;
  margin-right: 20px;
}
ol.bracketed-list li input {
  width: 90%;
  float: right;
}
</style>
